import React from 'react';
import Marquee from "react-fast-marquee";
import './marquee.css';
import star from '../../assets/star.png';
import {NewYear2025,chandrayaan,aditya,g20,worldcup2023, happydiwali,happyholidays,happyholi, ipl2024,flagofindia, canadaflag, independenceday2024, republicday, kishorekumar,happyholidays2} from './imports';
import {    faYoutube,    faFacebook,    faTwitter,    faInstagram  } from "@fortawesome/free-brands-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";


const marquee = () => {
  return (
    <div className='gpt3__marquee-component'>
      <Marquee pauseOnHover="true" speed="40">

          <div className='gpt3__marquee-component-content'>p
          <img src={happyholidays2} height="50" alt="Princeton"/>
          <div className='gpt3__marquee-component-text'>
          Wishing Everyone Happy Holidays 2025 and Happy New Year 2026</div>
          <img src={happyholidays2} height="50" alt="Princeton"/>
          </div>
          
        </Marquee>
    </div>
  )
}


export default marquee
